import { SelectableColoredItem } from "../processingActivity/ProcessingActivity.types";
import { LegalEntityContactType } from "../legalEntity/legalEntityContactTab/LegalEntityContactTab.types";

export enum AssigneeType {
    LegalEntityContact = 1,
    ExternalUser = 2,
    User = 3,
}

export interface SelectableAssignee {
    id: string;
    name: string;
    email: string;
    assigneeType: AssigneeType;
    contactTypes: Array<LegalEntityContactType>;
    // Only external users and platform users carry business areas, so this is always empty for a contact.
    // Filtering the recipient list by business area therefore hides every contact, which is intended.
    businessAreas: Array<SelectableColoredItem>;
    legalEntityId?: string;
    legalEntityName?: string;
}
